import { render, staticRenderFns } from "./GoliveButtonComponents.vue?vue&type=template&id=20344891&"
import script from "./GoliveButtonComponents.vue?vue&type=script&lang=js&"
export * from "./GoliveButtonComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports